import React from 'react';
import { LockIcon } from 'lucide-react';
import { Panel } from './AdminPrimitives';
import { coreFixedRules } from '../../data/engagementAdmin';
import { useLocale } from '../../contexts/LocaleContext';
import type { L10n } from '../../types';
interface FixedRulesPanelProps {
  rules: L10n[];
}

/** Read-only product rules. Never editable from the Admin. */
export function FixedRulesPanel({
  rules
}: FixedRulesPanelProps) {
  const {
    tl
  } = useLocale();
  const all = [...rules, ...coreFixedRules];
  return <Panel title="Regras fixas do produto" hint="Somente leitura. Não são parâmetros configuráveis." data-id="element-494" data-mp="1gl7l9ugrz19t">
      <ul data-id="element-495" data-mp="1lm52o4tynra9">
        {all.map(rule => <li key={tl(rule)} className="flex items-start justify-between gap-3 border-b border-sand-line py-2 text-[12.5px] last:border-b-0" data-id="element-496" data-mp="1lj0p4gulvj6x">
            <span className="text-deep" data-id="element-497" data-mp="3ne1dtdc7uz4i">{tl(rule)}</span>
            <LockIcon size={13} className="mt-[3px] shrink-0 text-muted" aria-label="Somente leitura" data-id="element-498" data-mp="3sb1hxipi9rsz" />
          </li>)}
      </ul>
    </Panel>;
}